import React, {useState} from 'react';

import ButtonDrydock from './ButtonDrydock';
import CheckboxDrydock from './CheckboxDrydock';
import ChipDrydock from './ChipDrydock';
import CustomTableV2Drydock from './CustomTableV2Drydock';
import DropdownDrydock from './DropdownDrydock';
import InputDrydock from './InputDrydock';
import PaginationDrydock from './PaginationDrydock';
import SelectDrydock from './SelectDrydock';
import SelectCheckDrydock from './SelectCheckDrydock';
import ToastDrydock from './ToastDrydock';
import UserDrydock from './UserDrydock';

import TemplateFullPage from '../../Templates/TemplateFullPage';
import ContentSwitcher from '../../CoreWrappers/ContentSwitcher';
import StyledDrydock from './StyledDrydock';

const WizardsDrydock = () => {
	const sections = [
		{id: 'Button', Comp: ButtonDrydock},
		{id: 'Checkbox', Comp: CheckboxDrydock},
		{id: 'Chip', Comp: ChipDrydock},
		{id: 'CustomTableV2', Comp: CustomTableV2Drydock},
		{id: 'Dropdown', Comp: DropdownDrydock},
		{id: 'Input', Comp: InputDrydock},
		{id: 'Pagination', Comp: PaginationDrydock},
		{id: 'Select', Comp: SelectDrydock},
		{id: 'SelectCheckbox', Comp: SelectCheckDrydock},
		{id: 'ToastMessage', Comp: ToastDrydock},
		{id: 'User', Comp: UserDrydock}
	];

	const [selected, setSelected] = useState('Button');

	const renderSwitcher = () => {
		const props = {
			options: sections.map(({id}) => ({id, label: id})),
			value: sections.find(({id}) => selected === id),
			onChange: ({id}) => setSelected(id)
		};

		return (
			<div className="full">
				<ContentSwitcher {...props} />
			</div>
		);
	};

	return (
		<TemplateFullPage>
			<StyledDrydock className="styled-drydock">
				{renderSwitcher()}
				{sections.map(({id, Comp}) => id === selected && <Comp key={id} />)}
			</StyledDrydock>
		</TemplateFullPage>
	);
};

export default WizardsDrydock;
